module.exports = __webpack_public_path__ + "img/backHome_06.221e02a6.png";